export const docsPages = {
  "index": {
    "v1": {
      "title": "Guide",
      "href": "https://docs.hatchet.run/v1"
    },
    "cookbooks": {
      "title": "Cookbooks",
      "href": "https://docs.hatchet.run/cookbooks"
    },
    "self-hosting": {
      "title": "Self-Hosting",
      "href": "https://docs.hatchet.run/self-hosting"
    },
    "reference": {
      "title": "Reference",
      "href": "https://docs.hatchet.run/reference"
    },
    "contributing": {
      "title": "Contributing",
      "href": "https://docs.hatchet.run/contributing"
    },
    "agent-instructions": {
      "title": "Agent Instructions",
      "href": "https://docs.hatchet.run/agent-instructions"
    }
  },
  "cookbooks": {
    "index": {
      "title": "Overview",
      "href": "https://docs.hatchet.run/cookbooks/index"
    },
    "webhooks-stripe": {
      "title": "Stripe",
      "href": "https://docs.hatchet.run/cookbooks/webhooks-stripe"
    },
    "webhooks-github": {
      "title": "GitHub",
      "href": "https://docs.hatchet.run/cookbooks/webhooks-github"
    },
    "webhooks-slack": {
      "title": "Slack",
      "href": "https://docs.hatchet.run/cookbooks/webhooks-slack"
    },
    "workflow-support-agent": {
      "title": "Support Agent",
      "href": "https://docs.hatchet.run/cookbooks/workflow-support-agent"
    },
    "welcome-email": {
      "title": "Welcome Email",
      "href": "https://docs.hatchet.run/cookbooks/welcome-email"
    },
    "durable-tasks-vs-dags": {
      "title": "Durable Tasks vs DAGs",
      "href": "https://docs.hatchet.run/cookbooks/durable-tasks-vs-dags"
    }
  },
  "reference": {
    "python": {
      "title": "Python SDK",
      "href": "https://docs.hatchet.run/reference/python",
      "client": {
        "title": "Client",
        "href": "https://docs.hatchet.run/reference/python/client"
      },
      "context": {
        "title": "Context",
        "href": "https://docs.hatchet.run/reference/python/context"
      },
      "feature-clients": {
        "title": "Feature Clients",
        "href": "https://docs.hatchet.run/reference/python/feature-clients",
        "cron": {
          "title": "Cron",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/cron"
        },
        "filters": {
          "title": "Filters",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/filters"
        },
        "logs": {
          "title": "Logs",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/logs"
        },
        "metrics": {
          "title": "Metrics",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/metrics"
        },
        "rate_limits": {
          "title": "Rate Limits",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/rate_limits"
        },
        "runs": {
          "title": "Runs",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/runs"
        },
        "scheduled": {
          "title": "Scheduled",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/scheduled"
        },
        "webhooks": {
          "title": "Webhooks",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/webhooks"
        },
        "workers": {
          "title": "Workers",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/workers"
        },
        "workflows": {
          "title": "Workflows",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/workflows"
        }
      },
      "runnables": {
        "title": "Runnables",
        "href": "https://docs.hatchet.run/reference/python/runnables"
      },
      "asyncio": {
        "title": "Asyncio",
        "href": "https://docs.hatchet.run/reference/python/asyncio"
      },
      "pydantic": {
        "title": "Pydantic",
        "href": "https://docs.hatchet.run/reference/python/pydantic"
      },
      "lifespans": {
        "title": "Lifespans",
        "href": "https://docs.hatchet.run/reference/python/lifespans"
      },
      "dependency-injection": {
        "title": "Dependency Injection",
        "href": "https://docs.hatchet.run/reference/python/dependency-injection"
      },
      "dataclasses": {
        "title": "Dataclass Support",
        "href": "https://docs.hatchet.run/reference/python/dataclasses"
      }
    },
    "typescript": {
      "title": "Typescript SDK",
      "href": "https://docs.hatchet.run/reference/typescript",
      "client": {
        "title": "Client",
        "href": "https://docs.hatchet.run/reference/typescript/client"
      },
      "Context": {
        "title": "Context",
        "href": "https://docs.hatchet.run/reference/typescript/Context"
      },
      "feature-clients": {
        "title": "Feature Clients",
        "href": "https://docs.hatchet.run/reference/typescript/feature-clients",
        "crons": {
          "title": "Crons",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/crons"
        },
        "filters": {
          "title": "Filters",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/filters"
        },
        "logs": {
          "title": "Logs",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/logs"
        },
        "metrics": {
          "title": "Metrics",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/metrics"
        },
        "ratelimits": {
          "title": "Ratelimits",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/ratelimits"
        },
        "runs": {
          "title": "Runs",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/runs"
        },
        "schedules": {
          "title": "Schedules",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/schedules"
        },
        "webhooks": {
          "title": "Webhooks",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/webhooks"
        },
        "workers": {
          "title": "Workers",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/workers"
        },
        "workflows": {
          "title": "Workflows",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/workflows"
        }
      },
      "Runnables": {
        "title": "Runnables",
        "href": "https://docs.hatchet.run/reference/typescript/Runnables"
      }
    },
    "cli": {
      "title": "CLI Reference",
      "href": "https://docs.hatchet.run/reference/cli",
      "index": {
        "title": "Setup & Installation",
        "href": "https://docs.hatchet.run/reference/cli/index"
      },
      "profiles": {
        "title": "Profiles",
        "href": "https://docs.hatchet.run/reference/cli/profiles"
      },
      "running-hatchet-locally": {
        "title": "Running Hatchet Locally",
        "href": "https://docs.hatchet.run/reference/cli/running-hatchet-locally"
      },
      "running-workers-locally": {
        "title": "Running Workers Locally",
        "href": "https://docs.hatchet.run/reference/cli/running-workers-locally"
      },
      "triggering-workflows": {
        "title": "Triggering Workflows",
        "href": "https://docs.hatchet.run/reference/cli/triggering-workflows"
      },
      "tui": {
        "title": "Using the Hatchet TUI",
        "href": "https://docs.hatchet.run/reference/cli/tui"
      }
    }
  },
  "self-hosting": {
    "index": {
      "title": "Introduction",
      "href": "https://docs.hatchet.run/self-hosting/index"
    },
    "hatchet-lite": {
      "title": "Hatchet Lite",
      "href": "https://docs.hatchet.run/self-hosting/hatchet-lite"
    },
    "docker-compose": {
      "title": "Docker Compose",
      "href": "https://docs.hatchet.run/self-hosting/docker-compose"
    },
    "kubernetes-quickstart": {
      "title": "Quickstart",
      "href": "https://docs.hatchet.run/self-hosting/kubernetes-quickstart"
    },
    "networking": {
      "title": "Networking",
      "href": "https://docs.hatchet.run/self-hosting/networking"
    },
    "kubernetes-helm-configuration": {
      "title": "Configuring the Helm Chart",
      "href": "https://docs.hatchet.run/self-hosting/kubernetes-helm-configuration"
    },
    "kubernetes-external-database": {
      "title": "Setting up an External Database",
      "href": "https://docs.hatchet.run/self-hosting/kubernetes-external-database"
    },
    "high-availability": {
      "title": "High Availability",
      "href": "https://docs.hatchet.run/self-hosting/high-availability"
    },
    "configuration-options": {
      "title": "Engine Configuration Options",
      "href": "https://docs.hatchet.run/self-hosting/configuration-options"
    },
    "using-pgbouncer": {
      "title": "Using PgBouncer",
      "href": "https://docs.hatchet.run/self-hosting/using-pgbouncer"
    },
    "prometheus-metrics": {
      "title": "Prometheus Metrics",
      "href": "https://docs.hatchet.run/self-hosting/prometheus-metrics"
    },
    "worker-configuration-options": {
      "title": "Worker Configuration Options",
      "href": "https://docs.hatchet.run/self-hosting/worker-configuration-options"
    },
    "upgrading-downgrading": {
      "title": "Upgrading and Downgrading",
      "href": "https://docs.hatchet.run/self-hosting/upgrading-downgrading"
    },
    "downgrading-db-schema-manually": {
      "title": "Downgrading DB Schema Manually",
      "href": "https://docs.hatchet.run/self-hosting/downgrading-db-schema-manually"
    },
    "benchmarking": {
      "title": "Benchmarking",
      "href": "https://docs.hatchet.run/self-hosting/benchmarking"
    },
    "data-retention": {
      "title": "Data Retention",
      "href": "https://docs.hatchet.run/self-hosting/data-retention"
    },
    "improving-performance": {
      "title": "Improving Performance",
      "href": "https://docs.hatchet.run/self-hosting/improving-performance"
    },
    "read-replicas": {
      "title": "Read Replicas",
      "href": "https://docs.hatchet.run/self-hosting/read-replicas"
    },
    "sampling": {
      "title": "Trace Sampling",
      "href": "https://docs.hatchet.run/self-hosting/sampling"
    },
    "smtp-server": {
      "title": "SMTP Server",
      "href": "https://docs.hatchet.run/self-hosting/smtp-server"
    }
  },
  "v1": {
    "index": {
      "title": "\ud83e\ude93 What is Hatchet?",
      "href": "https://docs.hatchet.run/v1/index"
    },
    "quickstart": {
      "title": "Quickstart",
      "href": "https://docs.hatchet.run/v1/quickstart"
    },
    "using-coding-agents": {
      "title": "Using Coding Agents",
      "href": "https://docs.hatchet.run/v1/using-coding-agents"
    },
    "tasks": {
      "title": "Tasks",
      "href": "https://docs.hatchet.run/v1/tasks"
    },
    "workers": {
      "title": "Workers",
      "href": "https://docs.hatchet.run/v1/workers"
    },
    "running-your-task": {
      "title": "Running Tasks",
      "href": "https://docs.hatchet.run/v1/running-your-task"
    },
    "durable-execution": {
      "title": "Durable Execution",
      "href": "https://docs.hatchet.run/v1/durable-execution"
    },
    "scheduled-runs": {
      "title": "Scheduled Runs",
      "href": "https://docs.hatchet.run/v1/scheduled-runs"
    },
    "cron-runs": {
      "title": "Cron Runs",
      "href": "https://docs.hatchet.run/v1/cron-runs"
    },
    "bulk-run": {
      "title": "Bulk Triggering",
      "href": "https://docs.hatchet.run/v1/bulk-run"
    },
    "events": {
      "title": "Events",
      "href": "https://docs.hatchet.run/v1/events"
    },
    "webhooks": {
      "title": "Webhooks",
      "href": "https://docs.hatchet.run/v1/webhooks"
    },
    "inter-service-triggering": {
      "title": "Inter-Service Triggering",
      "href": "https://docs.hatchet.run/v1/inter-service-triggering"
    },
    "retry-policies": {
      "title": "Retry Policies",
      "href": "https://docs.hatchet.run/v1/retry-policies"
    },
    "timeouts": {
      "title": "Timeouts",
      "href": "https://docs.hatchet.run/v1/timeouts"
    },
    "cancellation": {
      "title": "Cancellation",
      "href": "https://docs.hatchet.run/v1/cancellation"
    },
    "bulk-retries-and-cancellations": {
      "title": "Bulk Retries & Cancellations",
      "href": "https://docs.hatchet.run/v1/bulk-retries-and-cancellations"
    },
    "concurrency": {
      "title": "Concurrency",
      "href": "https://docs.hatchet.run/v1/concurrency"
    },
    "rate-limits": {
      "title": "Rate Limits",
      "href": "https://docs.hatchet.run/v1/rate-limits"
    },
    "priority": {
      "title": "Priority",
      "href": "https://docs.hatchet.run/v1/priority"
    },
    "durable-tasks": {
      "title": "Durable Tasks",
      "href": "https://docs.hatchet.run/v1/durable-tasks"
    },
    "child-spawning": {
      "title": "Child Spawning",
      "href": "https://docs.hatchet.run/v1/child-spawning"
    },
    "durable-sleep": {
      "title": "Sleeps",
      "href": "https://docs.hatchet.run/v1/durable-sleep"
    },
    "durable-event-waits": {
      "title": "Event Waits",
      "href": "https://docs.hatchet.run/v1/durable-event-waits"
    },
    "task-eviction": {
      "title": "Task Eviction",
      "href": "https://docs.hatchet.run/v1/task-eviction"
    },
    "directed-acyclic-graphs": {
      "title": "DAGs as Durable Workflows",
      "href": "https://docs.hatchet.run/v1/directed-acyclic-graphs"
    },
    "docker": {
      "title": "Running with Docker",
      "href": "https://docs.hatchet.run/v1/docker"
    },
    "autoscaling-workers": {
      "title": "Autoscaling Workers",
      "href": "https://docs.hatchet.run/v1/autoscaling-workers"
    },
    "advanced-assignment": {
      "title": "Advanced Assignment",
      "href": "https://docs.hatchet.run/v1/advanced-assignment",
      "sticky-assignment": {
        "title": "Sticky Assignment",
        "href": "https://docs.hatchet.run/v1/advanced-assignment/sticky-assignment"
      },
      "worker-affinity": {
        "title": "Worker Affinity",
        "href": "https://docs.hatchet.run/v1/advanced-assignment/worker-affinity"
      },
      "manual-slot-release": {
        "title": "Manual Slot Release",
        "href": "https://docs.hatchet.run/v1/advanced-assignment/manual-slot-release"
      }
    },
    "logging": {
      "title": "Logging",
      "href": "https://docs.hatchet.run/v1/logging"
    },
    "opentelemetry": {
      "title": "OpenTelemetry",
      "href": "https://docs.hatchet.run/v1/opentelemetry"
    },
    "worker-healthchecks": {
      "title": "Worker Health Checks",
      "href": "https://docs.hatchet.run/v1/worker-healthchecks"
    },
    "prometheus-metrics": {
      "title": "Prometheus Metrics",
      "href": "https://docs.hatchet.run/v1/prometheus-metrics"
    },
    "additional-metadata": {
      "title": "Additional Metadata",
      "href": "https://docs.hatchet.run/v1/additional-metadata"
    },
    "middleware": {
      "title": "Middleware",
      "href": "https://docs.hatchet.run/v1/middleware"
    },
    "streaming": {
      "title": "Streaming",
      "href": "https://docs.hatchet.run/v1/streaming"
    },
    "environments": {
      "title": "Environments",
      "href": "https://docs.hatchet.run/v1/environments"
    },
    "troubleshooting": {
      "title": "Troubleshooting",
      "href": "https://docs.hatchet.run/v1/troubleshooting",
      "index": {
        "title": "Troubleshooting Workers",
        "href": "https://docs.hatchet.run/v1/troubleshooting/index"
      }
    },
    "architecture-and-guarantees": {
      "title": "Architecture & Guarantees",
      "href": "https://docs.hatchet.run/v1/architecture-and-guarantees"
    },
    "cloud-vs-oss": {
      "title": "Cloud vs OSS",
      "href": "https://docs.hatchet.run/v1/cloud-vs-oss"
    },
    "security": {
      "title": "Security",
      "href": "https://docs.hatchet.run/v1/security",
      "index": {
        "title": "About",
        "href": "https://docs.hatchet.run/v1/security/index"
      },
      "audit-logs": {
        "title": "Audit Logs",
        "href": "https://docs.hatchet.run/v1/security/audit-logs"
      }
    },
    "region-availability": {
      "title": "Region Availability",
      "href": "https://docs.hatchet.run/v1/region-availability"
    },
    "uptime": {
      "title": "Uptime",
      "href": "https://docs.hatchet.run/v1/uptime"
    },
    "developer-experience": {
      "title": "Developer Experience",
      "href": "https://docs.hatchet.run/v1/developer-experience"
    },
    "faq": {
      "title": "Frequently Asked Questions",
      "href": "https://docs.hatchet.run/v1/faq"
    },
    "compute": {
      "title": "Managed Compute",
      "href": "https://docs.hatchet.run/v1/compute",
      "index": {
        "title": "Overview",
        "href": "https://docs.hatchet.run/v1/compute/index"
      },
      "getting-started": {
        "title": "Getting Started",
        "href": "https://docs.hatchet.run/v1/compute/getting-started"
      },
      "cpu": {
        "title": "CPU Machine Types",
        "href": "https://docs.hatchet.run/v1/compute/cpu"
      },
      "gpu": {
        "title": "GPU Machine Types",
        "href": "https://docs.hatchet.run/v1/compute/gpu"
      },
      "git-ops": {
        "title": "GitOps",
        "href": "https://docs.hatchet.run/v1/compute/git-ops"
      },
      "auto-scaling": {
        "title": "Auto Scaling",
        "href": "https://docs.hatchet.run/v1/compute/auto-scaling"
      },
      "environment-variables": {
        "title": "Environment Variables",
        "href": "https://docs.hatchet.run/v1/compute/environment-variables"
      }
    },
    "migrating": {
      "title": "V0 to V1 Upgrade Guide",
      "href": "https://docs.hatchet.run/v1/migrating",
      "v1-sdk-improvements": {
        "title": "SDK Improvements",
        "href": "https://docs.hatchet.run/v1/migrating/v1-sdk-improvements"
      },
      "migration-guide-engine": {
        "title": "Engine Migration Guide",
        "href": "https://docs.hatchet.run/v1/migrating/migration-guide-engine"
      },
      "migration-guide-python": {
        "title": "Python Migration Guide",
        "href": "https://docs.hatchet.run/v1/migrating/migration-guide-python"
      },
      "migration-guide-typescript": {
        "title": "Typescript Migration Guide",
        "href": "https://docs.hatchet.run/v1/migrating/migration-guide-typescript"
      },
      "migration-guide-go": {
        "title": "Go Migration Guide",
        "href": "https://docs.hatchet.run/v1/migrating/migration-guide-go"
      }
    },
    "advanced-tasks": {
      "cancellation": {
        "title": "Cancellation",
        "href": "https://docs.hatchet.run/v1/advanced-tasks/cancellation"
      },
      "streaming": {
        "title": "Streaming",
        "href": "https://docs.hatchet.run/v1/advanced-tasks/streaming"
      },
      "additional-metadata": {
        "title": "Additional Metadata",
        "href": "https://docs.hatchet.run/v1/advanced-tasks/additional-metadata"
      }
    }
  },
  "agent-instructions": {
    "setup-cli": {
      "title": "Setup CLI",
      "href": "https://docs.hatchet.run/agent-instructions/setup-cli"
    },
    "start-worker": {
      "title": "Start Worker",
      "href": "https://docs.hatchet.run/agent-instructions/start-worker"
    },
    "trigger-and-watch": {
      "title": "Trigger & Watch",
      "href": "https://docs.hatchet.run/agent-instructions/trigger-and-watch"
    },
    "debug-run": {
      "title": "Debug a Run",
      "href": "https://docs.hatchet.run/agent-instructions/debug-run"
    },
    "replay-run": {
      "title": "Replay a Run",
      "href": "https://docs.hatchet.run/agent-instructions/replay-run"
    }
  },
  "contributing": {
    "index": {
      "title": "Contributing",
      "href": "https://docs.hatchet.run/contributing/index"
    },
    "github-app-setup": {
      "title": "GitHub App Setup",
      "href": "https://docs.hatchet.run/contributing/github-app-setup"
    },
    "sdks": {
      "title": "SDKs",
      "href": "https://docs.hatchet.run/contributing/sdks"
    }
  }
} as const;
